import AppImage from '@theme/components/atom/AppImage'
import AppTitle from '@theme/components/atom/AppTitle'
import ArticleBox from '@theme/components/content/ArticleBox'
import ArticleMenu from '@theme/components/content/ArticleMenu'
import ArticleTagList from '@theme/components/content/ArticleTagList'
import AuthorBox from '@theme/components/content/AuthorBox'
import Breadcrumbs from '@theme/components/molecule/Breadcrumbs'
import Container from '@theme/components/utils/Container'
import ContentBuilder from '@theme/components/utils/ContentBuilder'
import HeaderConfigurationMixin from '~/mixins/HeaderConfigurationMixin'
import ImageUrlMixin from '~/mixins/ImageUrlMixin'
import LayoutBase from '@theme/components/shop/LayoutBase'
import MenuItemPageMixin from '~/mixins/MenuItemPageMixin'
import SeoMixin from '~/mixins/SeoMixin'
import UtilityGridMixin from '~/mixins/UtilityGridMixin'
import _ from 'lodash'
import eventDefinitions from '~/events/eventDefinitions'

export default {
  components: {
    AppImage,
    AppTitle,
    ArticleBox,
    ArticleMenu,
    ArticleTagList,
    AuthorBox,
    Breadcrumbs,
    Container,
    ContentBuilder,
    LayoutBase,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    headerConfiguration: null,
    latestArticles: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      articleAuthors: [],
      articleCategories: [],
      articleTags: [],
      latestArticlesColumnGridClass: null,
      latestArticlesFiltered: null,
      logoUrl: this.imageUrl({ src: this.$store.state.globals.meta.seo_image }),
    }
  },
  head() {
    return this.getSeoHead()
  },
  computed: {
    articleCategoryLinks(vm) {
      let links = _.filter(vm.articleCategories, category => Boolean(category.page_meta))
      links = _.map(links, category => {
        return {
          _id: category._id,
          title: vm.$options.filters.prepositions(category.title),
          to: vm.localePath({
            ...(category.master_category && category.master_category.length
              ? {
                  name: 'articleList-slug-child',
                  params: {
                    slug: category.master_category[0].entity.page_meta.slug,
                    child: category.page_meta.slug,
                  },
                }
              : {
                  name: 'articleList-slug',
                  params: { slug: category.page_meta.slug },
                }),
          }),
        }
      })

      return _.filter(links, link => _.isString(link.to) || _.isObject(link.to))
    },
    breadcrumbs() {
      return [
        {
          title: this.$t('PageArticleDetail.breadcrumbs.index'),
          path: this.localePath({ name: 'articleList' }),
        },
        ...this.menuBreadcrumbs,
        {
          title: this.article.title,
          path: this.$route.path,
        },
      ]
    },
  },
  created() {
    if (this.article.article_category_reference && this.article.article_category_reference.length > 0) {
      this.articleCategories = this.article.article_category_reference.map(category =>
        _.pick(category.entity, ['_id', 'page_meta', 'title', 'master_category']),
      )
    }
    if (this.article.article_author_reference) {
      this.articleAuthors = this.article.article_author_reference.map(author =>
        _.pick(author.entity, ['_id', 'author_has_page', 'image', 'page_meta', 'perex', 'title']),
      )
    }
    if (this.article.article_tag_reference && this.article.article_tag_reference.length > 0) {
      this.articleTags = this.article.article_tag_reference.map(tag =>
        _.pick(tag.entity, ['_id', 'page_meta', 'title']),
      )
    }
    if (this.latestArticles.length > 0) {
      this.latestArticlesColumnGridClass = this.computeColumnClass(
        this.$themeSettings.components.PageArticleDetail.latestArticles.perLine
          ? this.$themeSettings.components.PageArticleDetail.latestArticles.perLine
          : this.$themeSettings.components.ArticleList.perLine,
      )
    }
  },
  mixins: [ImageUrlMixin, HeaderConfigurationMixin, MenuItemPageMixin, SeoMixin, UtilityGridMixin],
  mounted() {
    this.$eventBus.$emit(eventDefinitions.ARTICLE.PAGE_VIEW, {
      article: this.article,
    })
    this.latestArticlesFiltered = this.latestArticles
      .filter(item => item._id !== this.article._id && item.title)
      .splice(0, this.$themeSettings.components.PageArticleDetail.latestArticles.count)
  },
}
